<div fxLayout="row" fxLayoutAlign="start center center" style="width: 100%">

    <div fxLayout="column" fxFlex="grow">
        <div fxLayout="row" fxFlex="grow" [style.max-height.px]="tableHeight" style="overflow-y: auto;">
            <mat-table matSort [dataSource]="finalForms" [style.max-height.px]="tableHeight" fxFlex="grow" style="width: 100%;">

                <ng-container matColumnDef="title">
                    <mat-header-cell mat-sort-header class="tableHeaderCell" fxLayoutAlign="start center center" *matHeaderCellDef>
                        Τίτλος
                    </mat-header-cell>
                    <mat-cell class="tableCell" fxLayoutAlign="start center center"
                              *matCellDef="let element"> {{element.title}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="published_at">
                    <mat-header-cell mat-sort-header  class="tableHeaderCell" fxLayoutAlign="center center center" *matHeaderCellDef> Ημ.
                        Δημοσίευσης
                    </mat-header-cell>
                    <mat-cell class="tableCell" fxLayoutAlign="center center center"
                              *matCellDef="let element"> {{element.published_at?.substring(0, 10)}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="completed">
                    <mat-header-cell class="tableHeaderCell" fxLayoutAlign="center center center" *matHeaderCellDef>
                        Συμπλήρωσαν
                    </mat-header-cell>
                    <mat-cell class="tableCell" fxLayoutAlign="center center center" *matCellDef="let element">
                        <div fxLayout="column">
                            <div fxLayout="row"
                                 fxLayoutAlign="center center center">{{calculateOpened(element)}}</div>

                            <div fxLayout="row" fxLayoutAlign="center center center">
                                <mat-icon [ngStyle]="{'color': 'green'}">stop</mat-icon>&nbsp;Συμπλήρωσαν
                            </div>
                        </div>

                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="pending">
                    <mat-header-cell class="tableHeaderCell" fxLayoutAlign="center center center" *matHeaderCellDef> Σε
                        αναμονή
                    </mat-header-cell>
                    <mat-cell class="tableCell" fxLayoutAlign="center center center" *matCellDef="let element">
                        <div fxLayout="column">
                            <div fxLayout="row"
                                 fxLayoutAlign="center center center">{{calculatePending(element)}}</div>
                            <div fxLayout="row" fxLayoutAlign="center center center">
                                <mat-icon [ngStyle]="{'color': 'orange'}">stop</mat-icon>&nbsp;Σε αναμονή
                            </div>
                        </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="reminder">
                    <mat-header-cell class="tableHeaderCell" fxLayoutAlign="center center center" *matHeaderCellDef> Ημ.
                        υπενθύμισης
                    </mat-header-cell>
                    <mat-cell class="tableCell" fxLayoutAlign="center center center" *matCellDef="let element">

                        <ng-container *ngIf="pendingReminderRequest; then LoadingReminder else ShowReminder"></ng-container>
                        <ng-template #ShowReminder>
                         <span *ngIf="element.reminder_date"
                               style="color: var(--primary); cursor: pointer; text-decoration: underline;"
                               (click)="showRemindersInfo(element)">
                                {{element.reminder_sent}}
                         </span>

                            <span *ngIf="!element.reminder_date">
                                {{element.reminder_sent}}
                        </span>
                        </ng-template>

                    </mat-cell>
                </ng-container>

                <ng-template #LoadingReminder>
                    <div fxLayoutAlign="center center center">
                        <img src="assets/images/loading.gif" alt="loading" width="15" height="15" />
                    </div>
                </ng-template>

                <ng-container matColumnDef="actions">
                    <mat-header-cell class="tableHeaderCell" fxLayoutAlign="center center center" *matHeaderCellDef>
                        Ενέργειες
                    </mat-header-cell>
                    <mat-cell class="tableCell" fxLayoutAlign="center center center" *matCellDef="let element">

                        <div fxLayout="column" fxFlex="5">
                            <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" style="cursor: pointer;">

                                <div fxLayout="row" fxLayoutAlign="center center center">

                                    <button mat-icon-button>
                                        <mat-icon style="vertical-align: middle; color:var(--secondaryBlue);">
                                            more_vert
                                        </mat-icon>
                                    </button>

                                </div>
                            </div>

                            <mat-menu #menu="matMenu">
                                <mat-list>
                                    <mat-list-item class="menuList">
                                        <button matTooltip="Εξαγωγή σε Excel" [disabled]="element.completed === 0" mat-menu-item
                                                (click)="exportToExcel(element)">
                                            <mat-icon class="icon">description</mat-icon>&nbsp;Εξαγωγή σε Excel
                                        </button>
                                    </mat-list-item>
                                    <mat-list-item class="menuList">
                                        <button mat-menu-item (click)="sendNotification(element)">
                                            <mat-icon class="icon">send</mat-icon>&nbsp;Αποστολή ενημέρωσης
                                        </button>
                                    </mat-list-item>
                                </mat-list>
                            </mat-menu>
                        </div>


                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayColumns;"></mat-row>
            </mat-table>
        </div>
        <div *ngIf="isLoading">
            <app-skeleton-loading></app-skeleton-loading>
        </div>
        <div fxLayout="row" fxLayoutAlign="end center center"
             style="margin-top: 20px;">
            <mat-paginator #reportsPaginator
                           [length]="finalForms.data.length"
                           [pageSize]="200" [pageSizeOptions]="[10, 50, 100, 200]">
            </mat-paginator>
        </div>
    </div>

</div>
